import { useState } from "react"
import { Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { RoundedButton } from "../../../components/ui/roundButton"
import { updateAccountOwner } from "../../../services/scout"
import { useSnackbar } from "../../../components/SnackbarContext"

const Supervisor = ({ account, users, handleClose, handleSuccess }) => {

    const { showSnackbar } = useSnackbar()

    const [selectedUser, setSelectedUser] = useState(account?.created_by || "")

    return (
        <DefaultModal
            title={"Alterar gestor"}
            subtitle="Escolha o novo gestor abaixo"
            handleClose={handleClose}
            maxWidth="xs"
            action={
                <Box width="100%" display="flex" gap="1rem" sx={{ justifyContent: "space-between" }}>
                    <Box sx={{ width: "100%" }}>
                        <RoundedButton onClick={handleClose} rounded="outlined"  sx={{ width: "100%" }}>
                            Cancelar
                        </RoundedButton>
                    </Box>
                    <Box  sx={{ width: "100%" }}>
                        <span  sx={{ width: "100%" }}>
                            <RoundedButton  sx={{ width: "100%" }} onClick={async () => {
                                const response = await updateAccountOwner(account, selectedUser)
                                if (response.status === 200) {
                                    showSnackbar({ message: "Gestor atualizado com sucesso.", severity: "success" })
                                    handleSuccess()
                                } else {
                                    showSnackbar({ message: "Algo deu errado, tente novamente.", severity: "error" })
                                }
                            }}>
                                Salvar
                            </RoundedButton>
                        </span>
                    </Box>
                </Box>
            }
        >
            <Box display="flex" flexDirection="column" gap="1rem" margin="1rem 0">
                <div className="space-y-1.5">
                    <FormControl fullWidth size="small">
                        <InputLabel id="supervisor-label">Gestor</InputLabel>
                        <Select
                            labelId="supervisor-label"
                            value={selectedUser}
                            label="Gestor"
                            onChange={(event) => setSelectedUser(event.target.value)}
                        >
                            {users.map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.first_name} {user.last_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </Box>
        </DefaultModal>
    )
}

export default Supervisor
